var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VModal',{staticClass:"payment-method-wrapper",attrs:{"type":_vm.ModalType.custom}},[_c('VBlock',{attrs:{"id":"baemin-pay-layout"}},[_c('VBlock',{attrs:{"id":"baemin-pay-container"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }